import { render, staticRenderFns } from "./Acuiculturas.vue?vue&type=template&id=20a4d440"
import script from "./Acuiculturas.vue?vue&type=script&lang=js"
export * from "./Acuiculturas.vue?vue&type=script&lang=js"
import style0 from "./Acuiculturas.vue?vue&type=style&index=0&id=20a4d440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports